const FeatureFlagValue = {
  CONTROL: 'control',
  OFF: 'off',
  ON: 'on',
} as const;

export { FeatureFlagValue };
